import { Observable, of } from 'rxjs';
import { catchError, filter, first, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from '../../core.state';
import { LoadCertificationTypes } from './store/certification-type.actions';
import { selectCertificationTypesLoaded } from './store/certification-type.selectors';

@Injectable({
  providedIn: 'root'
})
export class CertificationTypeListGuard implements CanActivate {
  constructor(private store: Store<AppState>) { }

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(selectCertificationTypesLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(new LoadCertificationTypes());
        }
      }),
      filter(loaded => loaded),
      first()
    );
  }
}
